import React from "react";
import PropTypes from "prop-types";
import ImageModel from "src/common/models/prismic/components/ImageModel";
import RichText from "../Prismic/RichText";
import Article from "./Article";

import "./BlogArticles.scss";

const BlogArticles = (props) => (
  <section className="blog-articles">
    <div className="container-guttered">
      <RichText fields={props.title} className="blog-articles-title" />
      <div className="blog-articles-wrapper">
        {props.items.map((item, i) => (
          <Article
            key={i}
            image={item.image}
            link={item.link}
            category={item.category}
            categoryLink={item.categoryLink}
            title={item.title}
            content={item.content}
            hidden={item.isVisibleOnMobile === "false"}
          />
        ))}
      </div>
    </div>
  </section>
);

BlogArticles.propTypes = {
  title: PropTypes.array.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: ImageModel.propTypes.isRequired,
      link: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired,
      categoryLink: PropTypes.string,
      title: PropTypes.string.isRequired,
      content: PropTypes.array.isRequired,
      isVisibleOnMobile: PropTypes.string,
    })
  ).isRequired,
};

export default BlogArticles;
